import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import FilterableAttributes from '../../components/Query/Attributes/FilterableAttributes';
import { Login as LoginBox } from '../../components/Query/User';
import CartService from '../../services/CartService';
import { CurrencyFormatter } from '../../utils/utils';
import { Button, ProductBox } from '../modules';
import CountryService from '../../services/CountryService';
import Icon from '../Icon/Icon';

interface IModalProps extends RouteComponentProps<{ language: string }> {
  type?: string;
  open: boolean;
  onClose: () => any;
  variant?: GQL.IProductVariant;
  children?: any;
  language?: string;
  disableScrollBody?: boolean;
  // počet právě přidaných produktů do košíku
  quantity?: number;
}

class Modal extends React.Component<IModalProps> {
  private node: any;

  constructor(props: IModalProps) {
    super(props);

    this.state = {
      isOpened: props.open
    };

    this.handleClose = this.handleClose.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.goToCart = this.goToCart.bind(this);
    this.returnToShop = this.returnToShop.bind(this);
  }

  public handleClose() {
    if (this.props.disableScrollBody === true) {
      if (document) {
        document.body.style.overflow = '';
      }
    }
    document.removeEventListener('click', this.handleOutsideClick, false);
    this.props.onClose();
  }

  public handleOutsideClick(e: any) {
    if (!this.node) {
      document.removeEventListener('click', this.handleOutsideClick, false);
      return;
    }

    if (this.node.contains(e.target)) {
      return;
    }

    this.handleClose();
  }

  public componentDidMount() {
    if (this.props.disableScrollBody === true) {
      if (document) {
        document.body.style.overflow = 'hidden';
      }
    }
  }

  public render() {
    const name: string = 'modal';
    const { type, children } = this.props;

    if (!this.props.open) {
      return null;
    }

    document.addEventListener('click', this.handleOutsideClick, false);

    const watchdogEmailFormType = 'watchdog-email-form';
    let typeSwich = type;
    if ('string' === typeof type) {
      const watchdogEmailFormExtendedType = watchdogEmailFormType + '-in-';
      if (watchdogEmailFormExtendedType === type.substr(0, watchdogEmailFormExtendedType.length)) {
        typeSwich = watchdogEmailFormType;
      }
    }

    switch (typeSwich) {
      case 'vatRequestForm':
      case 'inquiryForm':
      case 'countrySelect':
        return (
          <React.Fragment>
            <div className="modal-overlay" />
            <div className={name + (type ? ' ' + name + '--' + type : '')}>
              <div
                className="modal__content"
                ref={node => {
                  this.node = node;
                }}
              >
                {this.props.children}
              </div>
            </div>
          </React.Fragment>
        );

      case 'general':
        return (
          <div className={name + (type ? ' ' + name + '--' + type : '')}>
            <div
              className="modal__content"
              ref={node => {
                this.node = node;
              }}
            >
              {this.props.children}
            </div>
          </div>
        );
        
      case 'message':
        return (
          <div className={name + (type ? ' ' + name + '--' + type : '')}>
            <div
              className="modal__content"
              ref={node => {
                this.node = node;
              }}
            >
              {this.props.children}
            </div>
          </div>
        );

      case 'storeView':
        return (
          <div className={name + (type ? ' ' + name + '--' + type : '')}>
            <div
              className="modal__content"
              ref={node => {
                this.node = node;
              }}
            >
              <div className="modal__title">Interaktivní prohlídka</div>
              {this.props.children}
            </div>
          </div>
        );

      case 'login':
        return (
          <div className={name + (type ? ' ' + name + '--' + type : '')}>
            <div
              ref={node => {
                this.node = node;
              }}
            >
              <LoginBox type="popup" onClose={this.handleClose} />
            </div>
          </div>
        );

      case 'sizeChart':
        return (
          <div className={name + (type ? ' ' + name + '--' + type : '')}>
            <div
              ref={node => {
                this.node = node;
              }}
              className="modal__box"
            >
              {children}
            </div>
          </div>
        );
        
      case 'toCart':
      default:
        const { variant, quantity } = this.props;
        let orderItemQuantity = 0;
        if (variant) {
          orderItemQuantity = CartService.GetInstance().getQuantityForVariant(variant.id);
        }
        const maxQuantity = variant && CartService.GetInstance().getMaxTypeQuantity(variant);
        const useMaxQuantity = (quantity || 0) > orderItemQuantity;

        return (
          <div className={name + (type ? ' ' + name + '--' + type : '')}>
            <div
              ref={node => {
                this.node = node;
              }}
              className="modal__box"
            >
              <div className="modal__head">
                <Icon type={'confirm'} />
                <div className="modal__title">
                  Product has been added to your cart
                </div>
                <button className="modal__close" onClick={this.handleClose} />
              </div>
              <div className="modal__body">
                <div className="modal__main">
                  <FilterableAttributes>
                    {({ attributes }: any) => (
                      <ProductBox
                        language={this.props.language}
                        variant={this.props.variant}
                        boxType="modal"
                        quantity={useMaxQuantity ? maxQuantity?.value || undefined : this.props.quantity}
                        attributes={attributes.attributes}
                      />
                    )}
                  </FilterableAttributes>
                </div>
                {useMaxQuantity && <div className="modal__title" style={{ background: 'red', color: 'white', margin: '0 10px', padding: 10, fontWeight: 'bold', textAlign: 'center' }}>
                  {maxQuantity?.type === 'PURCHASELIMITQUANTITY' ? `Only ${maxQuantity.value} pcs can be in the cart` : `We have only ${maxQuantity?.value} pcs in stock`}
                </div>}
                <div className="modal__side">
                  <div className="modal__finalPrice">
                    In Cart is total {CartService.GetInstance().totalQuantity} pcs for: <CurrencyFormatter price={CartService.GetInstance().totalPriceWithoutVat} />
                  </div>
                </div>
              </div>
              <div className="modal__footer">
                <Button onClick={this.returnToShop} type="return">
                  Continue shopping
                </Button>
                <Button onClick={this.goToCart} type="proceed">
                  Show cart
                </Button>
              </div>
            </div>
          </div>
        );

      case watchdogEmailFormType:
        return (
          <React.Fragment>
            <div className={name + (type ? ' ' + name + '--' + type : '')}>
              <div
                ref={node => { this.node = node; }}
                className="modal__box"
              >
                <div
                  className="modal__content"
                  ref={node => {
                    this.node = node;
                  }}
                >
                  {this.props.children}
                </div>
              </div>
            </div>
          </React.Fragment>
        );
    }

    return null;
  }

  private returnToShop() {
    this.props.onClose();
  }

  private goToCart() {
    const { countryCode } = CountryService.GetInstance();

    // Country code urls are not used anymore
    // this.props.history.push(`/${countryCode}/cart`);
    this.props.history.push('/cart');
    this.props.onClose();
  }
}

export default withRouter(Modal);



// WEBPACK FOOTER //
// ./src/modules/Modal/Modal.tsx